<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="1000">
    <v-card>
      <v-card-title class="title-modal">
        <span class="headline">Presentación</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <div class="row">
            <div class="col">
              <v-combobox
                v-model="item.presentation_type"
                name="presentation_type"
                item-title="name"
                item-value="id"
                :items="filteredPresentationTypes"
                label="Tipo de presentacion*"
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
                clearable
                @update:modelValue="onPresentationTypeChange"
                :disabled="isEdit"
              ></v-combobox>
            </div>
            <div class="col">
              <v-text-field
                v-if="item?.presentation_type?.id != productoService.PRESENTATION_TYPE_PALLET"
                autocomplete="off"
                name="barcode"
                :label="item.composite_presentation == null ? 'Codigo de barras*' : 'Codigo de barras'"
                type="text"
                v-model="item.barcode"
                :rules="item.composite_presentation == null ? [rules.required] : []"
              />
            </div>
          </div>

          <div class="row mt-0" v-if="getPresentations(item).length > 0">
            <div class="col">
              <v-combobox
                v-if="getPresentations(item).length > 0"
                v-model="item.composite_presentation"
                name="composite_presentation"
                item-title="presentation_type.name"
                item-value="id"
                :items="getPresentations(item)"
                label="Composición de otra presentacion"
                autocomplete="off"
                clearable
                :disabled="item.presentation_type == null || isEdit"
                :rules="[rules.onlySelectFromList]"
              ></v-combobox>
            </div>
            <div class="col">
              <v-text-field
                v-if="getPresentations(item).length > 0"
                :disabled="item.composite_presentation == null"
                autocomplete="off"
                name="amount_composite_presentation"
                label="Cantidad de la composición"
                :rules="[rules.decimal]"
                type="number"
                v-model="item.amount_composite_presentation"
              />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-combobox clearable v-model="item.weight_unit" name="weight_unit" item-title="name" item-value="id" :items="weight_units" label="Unidad de peso" autocomplete="off" :rules="[rules.onlySelectFromList]"></v-combobox>
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="weight" label="Peso" :rules="item.weight ? [rules.decimal] : []" type="number" v-model="item.weight" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <v-combobox
                clearable
                v-model="item.measure_unit"
                name="measure_unit"
                item-title="name"
                item-value="id"
                :items="measure_units"
                label="Unidad de medida"
                autocomplete="off"
                :rules="hasMeasures ? [rules.requiredComboBox, rules.onlySelectFromList] : [rules.onlySelectFromList]"
              ></v-combobox>
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="heigth" label="Alto" :rules="item.heigth ? [rules.decimal] : []" type="number" v-model="item.heigth" @update:modelValue="recalcVolume" />
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="width" label="Ancho" :rules="item.width ? [rules.decimal] : []" type="number" v-model="item.width" @update:modelValue="recalcVolume" />
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="length" label="Largo" :rules="item.length ? [rules.decimal] : []" type="number" v-model="item.length" @update:modelValue="recalcVolume" />
            </div>
          

          
            <div class="col-md-4">
              <v-text-field
                autocomplete="off"
                name="volume"
                :label="'Volumen' + volumeUnitLabel"
                :rules="item.volume ? [rules.decimal] : []"
                type="number"
                v-model="item.volume"
                hint="Se calcula con Alto x Ancho x Largo. Se puede modificar a mano, pero al cambiar cualquier medida se vuelve a calcular."
                persistent-hint
              />
            </div>
          </div>

          <div class="row mt-0" v-if="item?.presentation_type?.id != productoService.PRESENTATION_TYPE_PALLET">
            <div class="col">
              <v-btn color="blue-darken-2" dark class="mb-4" @click="addAlias()" size="small">
                <v-icon left>mdi-plus</v-icon> AGREGAR ALIAS DE CODIGO DE BARRA
              </v-btn>

              <v-data-table
                :headers="header_alias"
                :items="item.barcodes_alias_arr"
                class="elevation-1"
                no-data-text="No hay alias de codigo de barra"
                hide-default-footer
                fixed-header
                style="max-height: 300px; overflow-y: auto;background-color: rgb(221, 225, 230);border: 1px solid #ccc;"                
              >
                <template v-slot:item="{ index }">
                  <tr>
                    <td>
                      <v-text-field
                        v-model="item.barcodes_alias_arr[index].barcode"
                        placeholder="Ingrese codigo de barra"
                        variant="underlined"
                        :error-messages="item.barcodes_alias_arr[index].errorMessage"
                        class="custom-text-field-table"
                        @change="validateAlias(index)"
                      ></v-text-field>
                    </td>

                    <td class="text-center" style="width: 110px">
                      <v-icon v-on:click="deleteAlias(index)" color="red" class="mr-2" small>mdi-delete</v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="$emit('updateDialog')"> Cancelar </v-btn>
        <v-btn color="green" text @click="addNewPresentation()"> {{ itemEdit != null ? "Editar" : "Agregar" }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { productoService } from "@/libs/ws/productoService";
import ValidMixin from "@/mixins/ValidMixin.vue";
export default {
  created() {},
  mixins: [ValidMixin],
  components: {},
  props: {
    dialog: Boolean,
    product: Object,
    updateDialog: Function,
    addPresentation: Function,
    itemEdit: Object,
    isEdit: Boolean
  },
  computed: {
    filteredPresentationTypes() {
      // Si no hay otras presentaciones disponibles, es una presentación base
      // Solo mostrar "Caja" o "Unidad"
      if (this.getPresentations(this.item).length === 0) {
        return this.presentation_types.filter(type => type.id != 3); // Suponiendo que 'Caja' tiene id 1 y 'Unidad' tiene id 2
      }
      // Si hay otras presentaciones, mostrar todos los tipos
      return this.presentation_types;
    },
    hasMeasures() {
      return [this.item.heigth, this.item.width, this.item.length, this.item.volume]
        .some((v) => v != null && v !== "" && parseFloat(v) > 0);
    },
    volumeUnitLabel() {
      const u = this.item.measure_unit != null ? this.item.measure_unit.name : null;
      return u ? ` (${u}³)` : "";
    },
  },
  data: () => ({
    productoService: productoService,
    item: {
      name: "",
      barcode: "",
      presentation_type: null,
      composite_presentation: null,
      amount_composite_presentation: null,
      storage_unit: null,
      weight_unit: null,
      weight: "",
      measure_unit: null,
      heigth: "",
      width: "",
      length: "",
      volume: "",
      sellable: true,
      barcodes_alias_arr: [],
    },
    defaultItem: null,
    presentations: [],
    weight_units: [],
    measure_units: [],
    presentation_types: [],
    header_alias: [
      { title: "Alias de codigo de barra", key: "barcode", sortable: false },
      { title: "Accion", sortable: false },
    ],
  }),
  watch: {
    dialog() {
      if (this.itemEdit == null) {
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemEdit));
      }

      // Normaliza barcodes_alias_arr: presentaciones legacy pueden no traer la clave, y hay que
      // conservar el id de los alias existentes (si se pierde, editCollection los trata como
      // nuevos, borra las filas viejas e inserta otras).
      if (!Array.isArray(this.item.barcodes_alias_arr)) {
        this.item.barcodes_alias_arr = [];
      }
      this.item.barcodes_alias_arr = this.item.barcodes_alias_arr.map((a) => ({
        id: a.id ?? 0,
        barcode: a.barcode,
        errorMessage: "",
      }));

      // volume llega de Doctrine como string con la escala completa ("24000.000000");
      // se normaliza para que el input no muestre esos decimales de mas.
      this.item.volume = (this.item.volume != null && this.item.volume !== "") ? parseFloat(this.item.volume) : "";
    },
  },
  mounted() {
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    recalcVolume() {
      const h = parseFloat(this.item.heigth) || 0;
      const w = parseFloat(this.item.width) || 0;
      const l = parseFloat(this.item.length) || 0;
      this.item.volume = (h > 0 && w > 0 && l > 0) ? parseFloat((h * w * l).toFixed(6)) : "";
    },
    getPresentations(item) {
      let presentations_aux = this.product.presentations.filter(x => x !== item);

      let merged = this.presentations.concat(presentations_aux);

      // si el item tiene un tipo de presentación seleccionado, saco las que tengan ese mismo type
      if (item.presentation_type && item.presentation_type.id) {
        merged = merged.filter(p => 
          !p.presentation_type || p.presentation_type.id !== item.presentation_type.id
        );
      }

      // hago unique por presentation_type.id
      const unique = [];
      const seen = new Set();

      for (const p of merged) {
        const typeId = p.presentation_type ? p.presentation_type.id : null;
        if (!seen.has(typeId)) {
          seen.add(typeId);
          unique.push(p);
        }
      }

      return unique;
    },

    loadComboData() {
      generalService.request(Constant.SECTION_UNITS + "/list_measure_units").then((response) => {
        this.measure_units = response.result.list;
      });
      generalService.request(Constant.SECTION_UNITS + "/list_weight_units").then((response) => {
        this.weight_units = response.result.list;
      });
      generalService.request(Constant.SECTION_UNITS + "/list_presentation_types").then((response) => {
        this.presentation_types = response.result.list;
      });

      if (this.product.id > 0)
        generalService.request(Constant.SECTION_PRODUCTS + "/presentations", "POST", { product: this.product.id }).then((response) => {
          this.presentations = response.result.list;
        });
    },
    addAlias() {
      this.item.barcodes_alias_arr.push({ id: 0, barcode: "", errorMessage: "" });
    },
    deleteAlias(index) {
      this.item.barcodes_alias_arr = this.item.barcodes_alias_arr.filter((_, i) => i !== index);
    },
    validateAlias(index) {
      const alias = this.item.barcodes_alias_arr[index];
      const barcodeIngresado = (alias.barcode || "").trim();

      if (!barcodeIngresado) {
        alias.errorMessage = "El alias no puede estar vacío.";
        return false;
      }

      if (barcodeIngresado.includes(" ")) {
        alias.errorMessage = "El alias no puede contener espacios.";
        return false;
      }

      if (this.item.barcode && barcodeIngresado === this.item.barcode.trim()) {
        alias.errorMessage = "El alias no puede ser igual al codigo de barra principal.";
        return false;
      }

      const repetido = this.item.barcodes_alias_arr.some((a, i) => i !== index && (a.barcode || "").trim() === barcodeIngresado);
      if (repetido) {
        alias.errorMessage = "El alias ya fue ingresado en esta presentación.";
        return false;
      }

      alias.errorMessage = "";
      return true;
    },
    validateAllAlias() {
      let valid = true;
      this.item.barcodes_alias_arr.forEach((_, index) => {
        if (!this.validateAlias(index)) valid = false;
      });
      return valid;
    },
    async addNewPresentation() {
      //completo el campo name con el nombre de la presentacion
      if (this.item.presentation_type && this.item.presentation_type.name) {
        this.item.name = this.item.presentation_type.name;
      }

      const { valid } = await this.$refs.form.validate();
      console.log("valid", valid, this.$refs.form);
      console.log(this.item.amount_composite_presentation);

      const aliasValid = this.validateAllAlias();

      if (valid && aliasValid) {
        const itemToEmit = JSON.parse(JSON.stringify(this.item));
        itemToEmit.barcodes_alias_arr = itemToEmit.barcodes_alias_arr.map((a) => ({ id: a.id, barcode: a.barcode }));
        this.$emit("addPresentation", itemToEmit);
      }
    },
  },
};
</script>
